import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "uplink_staff_token";
export const CUSTOMER_KEY = "uplink_customer_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const customer = localStorage.getItem(CUSTOMER_KEY);
  if (customer) config.headers["X-Customer-Token"] = customer;
  return config;
});

export const imgUrl = (path) => (path && path.startsWith("/api/") ? `${BACKEND_URL}${path}` : path);

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (!detail) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return String(detail);
}

export const rupiah = (n) => `Rp${Number(n || 0).toLocaleString("id-ID")}`;

export const COIN_VALUE = 100;
export const RUPIAH_PER_COIN = 1000;

export const pad2 = (n) => String(n).padStart(2, "0");

export const tableLabel = (floor, table) => (table ? `Meja ${pad2(table)} • Lantai ${floor}` : "Bawa pulang");

export const STATUS = {
  menunggu_pembayaran: { label: "Menunggu Pembayaran", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  menunggu_konfirmasi: { label: "Menunggu Konfirmasi", cls: "bg-orange-100 text-orange-800 border-orange-200" },
  diproses: { label: "Sedang Disiapkan", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  diantar: { label: "Diantar ke Meja", cls: "bg-sage-100 text-forest border-sage-200" },
  selesai: { label: "Selesai", cls: "bg-forest text-paper border-forest" },
  dibatalkan: { label: "Dibatalkan", cls: "bg-red-100 text-red-700 border-red-200" },
};

export const CATEGORIES = [
  { id: "semua", label: "Semua" },
  { id: "kopi", label: "Kopi" },
  { id: "nonkopi", label: "Nonkopi" },
  { id: "makanan", label: "Makanan" },
  { id: "camilan", label: "Camilan" },
  { id: "paket", label: "Paket" },
];

export const formatTime = (iso) =>
  new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
